@if (!route) {
  <span class="tab-nav__item" [attr.data-tab-anchor]="value" (click)="setActive()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
} @else {
  <a class="tab-nav__item" [attr.data-tab-anchor]="value" [routerLink]="route">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
